import React from 'react'
import PropTypes from 'prop-types'
import { NumberInput, required } from 'react-admin'

const IntegerWidget = props => (
    <div>
        <NumberInput
            step={1}
            source={props.fieldName}
            label={props.label}
            validate={ props.required ?  required() : null}
            {...props.styleProps}
        />
    </div>
)

IntegerWidget.propTypes = {
    schema: PropTypes.object.isRequired,
    fieldName: PropTypes.string,
    label: PropTypes.string,
    normalizer: PropTypes.func,
}

export default IntegerWidget
